import { Button } from "@/common/components/button";
import { useEffect, useState } from "react";

interface Props {
  data: any;
  packagingTypes: any;
  onSubmit: () => void;
  onBack: () => void;
  filePreview?: File | null;
  /** True while the file is being checked, so Next cannot be clicked twice. */
  loading?: boolean;
}

const PreviewInventory = ({
  data,
  onSubmit,
  onBack,
  filePreview,
  loading = false,
}: Props) => {
  const [previewData, __setPreviewData] = useState<Array<Record<string, any>>>(
    [],
  );

  const [headers, __setHeaders] = useState<string[]>([]);

  useEffect(() => {
    if (!filePreview) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      const binaryStr = e.target?.result;
      if (!binaryStr) return;

      // const workbook = read(binaryStr, { type: "binary" });
      // const sheetName = workbook.SheetNames[0];
      // const worksheet = workbook.Sheets[sheetName];
      // const jsonData = utils.sheet_to_json<Record<string, any>>(worksheet);
      // setPreviewData(jsonData);
      // if (jsonData.length > 0) {
      //   setHeaders(Object.keys(jsonData[0]));
      // }
    };

    reader.readAsBinaryString(filePreview);
  }, [filePreview]);

  return (
    <div className=" sm:w-[40rem] w-[20rem] mx-auto bg-white rounded-lg p-5">
      {/* Product Information */}
      <h3 className="font-semibold text-gray-800 mb-4">Product Information</h3>
      <div className="grid grid-cols-2 gap-y-6 gap-x-10 text-sm">
        <InfoItem label="Product" value={data?.name} />
      </div>
      {/* Document */}
      <div className="mt-8">
        <h3 className="font-semibold text-gray-800 mb-3">Document Uploaded</h3>

        <div className="flex items-center justify-between border border-dashed rounded-md px-4 py-3 bg-gray-50">
          <div className="flex items-center gap-3">
            <span className="text-gray-600">📄</span>
            <span className="text-sm font-medium">{filePreview?.name}</span>
          </div>
        </div>
      </div>

      {/* ****** preview excel ********** */}
      {/* {previewData.length > 0 && ( */}
      <div className="mt-6 border rounded-md overflow-hidden">
        <div className="max-h-[300px] overflow-auto">
          <table className="min-w-full border text-sm">
            <thead className="bg-gray-100 sticky top-0">
              <tr>
                {headers.map((header) => (
                  <th
                    key={header}
                    className="border px-3 py-2 text-left font-medium"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {previewData.map((row, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  {headers.map((header) => (
                    <td key={header} className="border px-3 py-2">
                      {row[header]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* )} */}

      {/* MED-686: "Next", not "Submit". This step only checks the file — the
          import happens on the pricing step after it, whose own button reads
          "Import inventory". Calling this one Submit told the uploader they had
          just imported their stock when nothing had been written yet.

          One full-width `justify-between`, the same as the pricing step. The
          previous markup nested an inner `justify-between` inside an outer
          `justify-center`: that shrank the row to its content width, so
          `justify-between` had no free space left to push the two buttons apart
          and they ended up sitting together in the middle. */}
      <div className="mt-10 flex justify-between gap-3">
        <Button type="button" onClick={onBack} secondary>
          Back
        </Button>

        {/* Checking the file is a round trip, and without this the button sat
            there looking idle and still clickable — a second click fired a
            second validation. Wording follows the row-errors step, which
            already says "Checking..." for the same request. */}
        <Button type="button" onClick={onSubmit} disabled={loading}>
          {loading ? "Checking..." : "Next"}
        </Button>
      </div>
    </div>
  );
};

export default PreviewInventory;

const InfoItem = ({ label, value }: { label: string; value: any }) => (
  <div>
    <p className="text-gray-500 mb-1">{label}</p>
    <p className="font-medium text-gray-900">{value}</p>
  </div>
);
